import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from '../../config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Link,
  LinkIcon,
} from '../../components'
import Styles from './About.css'

@CSSModules(Styles, {allowMultiple:true})
export default class AboutHrc extends Component {
  constructor(props) {
    super(props)
    this.state = { }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    const title = 'LGBTQ+ Equity'
    const url = config.domain + config.routes.aboutHrc
    const logoHrc = require('../../../static/images/logo-hrc.png')
    const clipboardClockGraphic = require( '../../../static/images/about/clipboard-clock-graphic.png' )

    //
    return <div>
      {container.helmet(title, '', url)}
      <ContainerDivs>
        
        
        <header styleName='header-subpage'>
          <h1 styleName='header-subpage__headline'>{title}</h1>
          <div styleName='header-subpage__image-banner--hrc' />
        </header>


        <section styleName='lede-content'>
          <br/>
          <br/>

          <p styleName='lede-content__copy'>
            <b>LGBTQ+ Equity ensures that all employees – regardless of their sexual orientation and gender identity – feel included in the workplace and have fair access to opportunities, resources, and the support needed to contribute, succeed, and thrive.</b>
          </p>

          <p styleName='lede-content__copy'>
            Even with progress in recent years, many LGBTQ+ employees still face challenges at work – whether it's subtle bias, lack of representation, or feeling like they can’t be fully themselves. These barriers don’t just affect individual wellbeing; they impact team culture, retention, and innovation.  
          </p>
          <p styleName='lede-content__copy'>
            When workplaces create comprehensive policies and offer benefits that ensure greater equity for LGBTQ+ workers, everyone benefits. Inclusive environments lead to stronger employee wellbeing, better retention, and more diverse perspectives that drive innovation. Teams become more collaborative when people feel seen, respected, and supported for who they are. It also sends a clear message to employees, customers, and the broader community that the organization values fairness, authenticity, and belonging.
          </p>
          <p styleName='lede-content__copy'>
            <b>Social Justice Funds</b> empowers investors to harness their personal economic power to support LGBTQ+ equity while maximizing returns.
          </p>
        </section>


        <section styleName='section-panel'>
          <h2 styleName='section-panel__headline'>
            Human Rights Campaign's Corporate Equality Index
          </h2>
          <div styleName='section-panel__content'>
            <div styleName='section-panel__copy-wrap'>
              <p styleName='section-panel__copy'>
                Our LGBTQ+ Equity data is powered by in-depth research from Human Rights Campaign (HRC). The <Link xstrong to='https://www.hrc.org/resources/corporate-equality-index' title='HRC Corporate Equality Index'>HRC Corporate Equality Index (CEI)</Link> is the national benchmarking tool on corporate policies, practices, and benefits pertinent to lesbian, gay, bisexual, transgender, and queer employees. The CEI assesses companies based on criteria such as non-discrimination protections, equitable benefits, inclusive culture, and corporate social responsibility.
              </p>
            </div>
            <div styleName='section-panel__image-wrap'>
               <img src={logoHrc} alt='Human Rights Campaign'  styleName='section-panel__hrc-logo'/> 
            </div>
          </div>
        </section>


        <section styleName='section-panel'>
          <div styleName='section-panel__image-wrap'>
            <img src={clipboardClockGraphic} alt='Visit our Action Toolkit'  styleName='section-panel__graphic-image'/>
          </div>
          <h2 styleName='section-panel__headline section-panel__headline--center section-panel__headline--purple'>
            Visit our Action Toolkit
          </h2>
          <div styleName='section-panel__narrow-content'>
            <ul styleName='section-panel__list section-panel__list--flush'>
              <li>
                Learn how to make a change and align your investments with LGBTQ+ equity
              </li>
              <li>
                Ask your financial advisor about Social Justice investing
              </li>
              <li>
                Push your employer to provide socially just investment options
              </li>
            </ul>

            <Link roundbutton to={config.routes.toolkit} title='Take action'>
              Take action
            </Link>
          </div>
        </section>


      </ContainerDivs>
    </div>
  }
}
